import { Injectable } from '@angular/core';
import { ESRSWebService } from './esrs-web.service';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { Impatto } from '../impatto/impatto.service';

export interface ESRS {
  id?: string;
  nomeBreve: string;
  descrizione: string;
  impatti: Impatto[];
  selected?: boolean;
  includi?: boolean;
  sottoTemi: ESRS[];
}

@Injectable({
  providedIn: 'root',
})
export class ESRSService {
  constructor(private readonly esrsWebService: ESRSWebService) {}

  /**
   * Funzione per selezionare le righe da far vedere nella grid
   * @param page pagina
   * @param pageSize record per pagina
   * @param ricerca risultato per ricerca
   * @param filters valori da filtrare
   * @param sortBy sort asc desc
   * @returns lista di righe
   */
  public getESRS(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) {
    return this.esrsWebService.get(page, pageSize, ricerca, filters, sortBy);
  }

  /**
   * Funzione per eliminare una riga da una lista
   * @param idESRS id della riga da eliminare
   * @returns
   */
  public deleteESRS(idESRS: any) {
    return this.esrsWebService.delete(idESRS);
  }

  public postEsrs(esrs: ESRS) {
    return this.esrsWebService.postEsrs(esrs);
  }
  public putEsrs(idEsrs: string, esrs: ESRS) {
    return this.esrsWebService.putEsrs(idEsrs, esrs);
  }

  public putEsrsTematica(idEsrs: string, idTematica: string, esrs: ESRS) {
    return this.esrsWebService.putEsrsTematica(idEsrs, idTematica, esrs);
  }

  public getEsrsById(idEsrs: string, idTematica: string) {
    return this.esrsWebService.getEsrsById(idEsrs, idTematica);
  }
}
